{
  "ar": "العربية",
  "bn": "বাংলা",
  "ca": "Català",
  "cs": "čeština",
  "cy": "Cymraeg",
  "de": "Deutsch",
  "en": "English",
  "es": "Español",
  "fa": "فارسی",
  "fi": "suomi",
  "fr": "Français",
  "gd": "Gàidhlig",
  "gl": "Galego",
  "hr": "Hrvatski",
  "hu": "Magyar",
  "id": "Bahasa Indonesia",
  "it": "Italiano",
  "ja": "日本語",
  "nl": "Nederlands",
  "nn": "Nynorsk",
  "oc": "Occitan",
  "pl": "Polski",
  "pt_BR": "Português brasileiro",
  "ru": "Русский",
  "sl": "Slovenščina",
  "sv": "Svenska",
  "zh_Hans": "简体字",
  "zh_Hant": "繁體字"
}
